import * as ACTIONS from 'constants/Actions'

const visibilityReducerDefaultState = {
    displayContactModal: false
};

export default(state = visibilityReducerDefaultState, action) => {
    switch(action.type) {
        case ACTIONS.DISPLAY_CONTACT_MODAL:
            return {
                ...state,
                displayContactModal: true
            }
        case ACTIONS.REMOVE_CONTACT_MODAL:
            return {
                ...state,
                displayContactModal: false
            }
        default:
            return state;
    }
}